const getCopyright = () => (`©2004-${new Date().getFullYear()} Sgcarmart, Singapore. All rights reserved.`);

export { getCopyright as g };
//# sourceMappingURL=utils-DV-S0hIC.js.map
